import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederUtlandDto from '../Models/VeilederUtlandDto';

const ba = 'a1-valgBa';
const ma = 'a2-valgMa';
const phd = 'a3-valgPhd';
const profesjon = 'a4-valgProfesjon';

const utdanningValg: RadioButtonValgModel<VeilederUtlandDto>[] = [
    {
        id: 'a1',
        value: ba,
        tekst: 'valgBa',
    },
    {
        id: 'a2',
        value: ma,
        tekst: 'valgMa',
    },
    {
        id: 'a3',
        value: phd,
        tekst: 'valgPhd',
    },
    {
        id: 'a4',
        value: profesjon,
        tekst: 'valgProfesjon',
    },
];

export default {
    a1_ba: ba,
    a2_ma: ma,
    a3_phd: phd,
    a4_profesjon: profesjon,
    utdanningValg,
};
